export const MAIN_PRODUCTION_HOST = 'app.venus.io';
export const VENUS_FLUX_URL = 'https://flux.venus.io';
export const VENUS_DOC_URL = 'https://docs-v4.venus.io';
export const VENUS_PRIME_DOC_URL = `${VENUS_DOC_URL}/whats-new/prime-yield`;

export const DISCORD_SERVER_URL = 'https://discord.com/servers/venus-protocol-912811548651708448';
export const VENUS_COMMUNITY_URL = 'https://community.venus.io/';
export const VENUS_GITHUB_URL = 'https://github.com/VenusProtocol/';
export const VENUS_DISCORD_URL = 'https://discord.gg/venus-protocol-912811548651708448';
export const VENUS_TELEGRAM_URL = 'https://t.me/venusprotocol';
